export enum POPOVER_PLACEMENT {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  LEFT_TOP = 'left-top',
  LEFT_BOTTOM = 'left-bottom',
  RIGHT_TOP = 'right-top',
  RIGHT_BOTTOM = 'right-bottom',
}

export const POPOVER_PLACEMENT_FLIPMAP = {
  [POPOVER_PLACEMENT.TOP]: POPOVER_PLACEMENT.BOTTOM,
  [POPOVER_PLACEMENT.BOTTOM]: POPOVER_PLACEMENT.TOP,
  [POPOVER_PLACEMENT.LEFT]: POPOVER_PLACEMENT.RIGHT,
  [POPOVER_PLACEMENT.RIGHT]: POPOVER_PLACEMENT.LEFT,
  [POPOVER_PLACEMENT.TOP_LEFT]: POPOVER_PLACEMENT.BOTTOM_LEFT,
  [POPOVER_PLACEMENT.TOP_RIGHT]: POPOVER_PLACEMENT.BOTTOM_RIGHT,
  [POPOVER_PLACEMENT.BOTTOM_LEFT]: POPOVER_PLACEMENT.TOP_LEFT,
  [POPOVER_PLACEMENT.BOTTOM_RIGHT]: POPOVER_PLACEMENT.TOP_RIGHT,
  [POPOVER_PLACEMENT.LEFT_TOP]: POPOVER_PLACEMENT.RIGHT_TOP,
  [POPOVER_PLACEMENT.LEFT_BOTTOM]: POPOVER_PLACEMENT.RIGHT_BOTTOM,
  [POPOVER_PLACEMENT.RIGHT_TOP]: POPOVER_PLACEMENT.LEFT_TOP,
  [POPOVER_PLACEMENT.RIGHT_BOTTOM]: POPOVER_PLACEMENT.LEFT_BOTTOM,
} as const;

export enum POPOVER_TRIGGER {
  HOVER = 'hover',
  FOCUS = 'focus',
  CLICK = 'click',
  CONTEXT_MENU = 'contextmenu',
}

export const POPOVER_GAP = 4;

export const DEFAULT_POPOVER_DURATION = 200;
